import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=58a94ec9&scoped=true"
import script from "./MyFavorites.vue?vue&type=script&lang=js"
export * from "./MyFavorites.vue?vue&type=script&lang=js"
import style0 from "./MyFavorites.vue?vue&type=style&index=0&id=58a94ec9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a94ec9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a94ec9')) {
      api.createRecord('58a94ec9', component.options)
    } else {
      api.reload('58a94ec9', component.options)
    }
    module.hot.accept("./MyFavorites.vue?vue&type=template&id=58a94ec9&scoped=true", function () {
      api.rerender('58a94ec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyFavorites.vue"
export default component.exports